// Auto-generated file: Do not modify directly. Changes may be overwritten. Version: 1.1.0.

/*
 * Following tokens have been deprecated in version 1.1.0, please update your theme:
 *
 * Interactive/Focus has been split into two separate tokens. Please define 'Interactive/Focus Inner' and 'Interactive/Focus Outer' instead.
 * 'Interactive/Background Default' is deprecated. Please use 'Input/Background Default' instead.
 * 'Interactive/Background Disabled' is deprecated. Please use 'Input/Background Disabled' instead.
 * 'Interactive/Background Hovered' is deprecated. Please use 'Input/Background Hovered' instead.
 * 'Interactive/Background Pressed' is deprecated. Please use 'Input/Background Pressed' instead.
 * 'Interactive/Border Default' is deprecated. Please use 'Input/Border Default' instead.
 * 'Interactive/Border Hovered' is deprecated. Please use 'Input/Border Hovered' instead.
 * 'Interactive/Border Disabled' is deprecated. Please use 'Input/Border Disabled' instead.
 * 'Interactive/Border Critical Default' is deprecated. Please use 'Input/Border Critical' instead.
 * 'Pill' is deprecated. Please use 'Circle' instead.
 */

import type { GDSTheme } from '../theme-types';

export const leagueTheme: GDSTheme = {
  colors: {
    surface: {
      background: {
        primary: '#FFFFFFFF',
        secondary: '#F8F8F8FF',
        tertiary: '#EAEEFBFF',
      },
      card: {
        primary: '#F8F7F6FF',
        secondary: '#FFFFFFFF',
        disabled: '#D7D7D7FF',
      },
      skeleton: {
        shimmer: {
          background: '#E7E7E7FF',
          overlay:
            'linear-gradient(90.0deg, #FFFFFF00 0%, #FFFFFF80 50%, #FFFFFFE5 70%, #FFFFFF00 100%)',
        },
      },
    },
    onSurface: {
      text: {
        primary: '#250D53FF',
        subdued: '#66686BFF',
        reversed: '#FFFFFFFF',
        critical: '#BA1B3BFF',
        success: '#00805AFF',
        warning: '#222222FF',
      },
      border: { subdued: '#D6D6D6FF', default: '#66686BFF' },
      icon: { primary: '#66686BFF' },
    },
    interactive: {
      action: {
        primary: '#501CD2FF',
        hovered: '#37209AFF',
        pressed: '#251669FF',
        subdued: '#66686BFF',
        disabled: '#D6D6D6FF',
      },
      icon: { default: '#FFFFFFFF', disabled: '#949494FF' },
      background: {
        default: '#FFFFFFFF',
        disabled: '#F0F0F0FF',
        hovered: '#F8F8F8FF',
        pressed: '#F0F0F0FF',
      },
      border: {
        default: '#949494FF',
        hovered: '#501CD2FF',
        disabled: '#D6D6D6FF',
        critical: { default: '#BA1B3BFF' },
      },
      focus: { inner: '#501CD2FF', outer: '#501CD2FF' },
    },
    critical: {
      background: { subdued: '#F9DEE3FF', secondary: '#FFFFFFFF' },
      border: { default: '#BA1B3BFF' },
      icon: '#BA1B3BFF',
    },
    warning: {
      background: { subdued: '#FFE4BBFF', secondary: '#FFFFFFFF' },
      border: { default: '#CF6902FF' },
      icon: '#CF6902FF',
    },
    success: {
      background: { subdued: '#E5F6F1FF', secondary: '#FFFFFFFF' },
      border: { default: '#00A876FF' },
      icon: '#00A876FF',
    },
    highlight: {
      background: { subdued: '#EAEEFBFF', secondary: '#FFFFFFFF' },
      border: { default: '#2E5CDFFF' },
      icon: '#2E5CDFFF',
    },
    decorative: {
      brand: {
        primary: {
          darkest: '#250D53FF',
          dark: '#3E16A3FF',
          default: '#501CD2FF',
          bright: '#B9A4EDFF',
          brightest: '#DCD2F6FF',
          pastel: '#EDE8FAFF',
        },
        secondary: {
          darkest: '#15846DFF',
          dark: '#00A886FF',
          default: '#01C3A2FF',
          bright: '#A5E7DAFF',
          brightest: '#D2F3ECFF',
          pastel: '#E8F8F5FF',
        },
        tertiary: {
          darkest: '#6E748EFF',
          dark: '#6E748EFF',
          default: '#C4CFFDFF',
          bright: '#D4DCFEFF',
          brightest: '#E4E9FEFF',
          pastel: '#F3F5FFFF',
        },
      },
    },
    primary: {
      background: {
        default: '#501CD2FF',
        hovered: '#37209AFF',
        pressed: '#251669FF',
        critical: {
          default: '#BA1B3BFF',
          hovered: '#A51834FF',
          pressed: '#711124FF',
        },
      },
      text: { default: '#FFFFFFFF', critical: { default: '#FFFFFFFF' } },
    },
    secondary: {
      background: {
        default: '#FFFFFF00',
        hovered: '#37209AFF',
        pressed: '#251669FF',
      },
      text: { default: '#501CD2FF', hovered: '#FFFFFFFF' },
      border: { default: '#501CD2FF' },
    },
    tertiary: {
      background: {
        default: '#FFFFFF00',
        hovered: '#37209AFF',
        pressed: '#251669FF',
      },
      text: { default: '#66686BFF', hovered: '#FFFFFFFF' },
      border: { default: '#949494FF' },
    },
    input: {
      border: {
        success: '#00A876FF',
        warning: '#CF6902FF',
        default: '#949494FF',
        hovered: '#501CD2FF',
        disabled: '#D6D6D6FF',
        critical: '#BA1B3BFF',
      },
      background: {
        default: '#FFFFFFFF',
        disabled: '#F0F0F0FF',
        hovered: '#F8F8F8FF',
        pressed: '#F0F0F0FF',
      },
    },
  },
  shadows: {
    card: { x: 0, y: 0, blur: 0, spread: 0, color: '#00000000' },
    dropdown: { x: 0, y: 4, blur: 8, spread: 0, color: '#0000001A' },
  },
  typography: {
    headingOne: {
      fontFamily: 'Mark Offc Pro',
      fontWeight: 700,
      lineHeight: 40,
      fontSize: 32,
      letterSpacing: 0.25,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    headingTwo: {
      fontFamily: 'Mark Offc Pro',
      fontWeight: 700,
      lineHeight: 32,
      fontSize: 24,
      letterSpacing: 0.25,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    headingThree: {
      fontFamily: 'Mark Offc Pro',
      fontWeight: 700,
      lineHeight: 28,
      fontSize: 20,
      letterSpacing: 0.25,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    headingFour: {
      fontFamily: 'Mark Offc Pro',
      fontWeight: 700,
      lineHeight: 24,
      fontSize: 18,
      letterSpacing: 0.25,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    subtitleOne: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 700,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    subtitleTwo: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 700,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    bodyOne: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: 'none',
      textDecoration: 'none',
    },
    bodyOneSecondary: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: 'none',
      textDecoration: 'none',
    },
    bodyTwo: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: 'none',
      textDecoration: 'none',
    },
    bodyTwoSecondary: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: 'none',
      textDecoration: 'none',
    },
    buttonOne: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    buttonTwo: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    label: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 500,
      lineHeight: 16,
      fontSize: 12,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    overline: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 700,
      lineHeight: 16,
      fontSize: 12,
      letterSpacing: 0.6000000238418579,
      paragraphSpacing: 0,
      textCase: 'uppercase',
      textDecoration: 'none',
    },
    caption: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 16,
      fontSize: 12,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    tab: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 500,
      lineHeight: 12,
      fontSize: 10,
      letterSpacing: 0.1599999964237213,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
  },
  spacing: {
    none: 0,
    eighth: 2,
    quarter: 4,
    half: 8,
    threeQuarters: 12,
    one: 16,
    oneAndHalf: 24,
    two: 32,
    twoAndHalf: 40,
    three: 48,
    four: 64,
    five: 80,
  },
  borderWidths: { thin: 1, thick: 2, outerFocus: 3, innerFocus: 3 },
  borderRadii: {
    none: 0,
    thin: 1,
    thick: 2,
    small: 3,
    medium: 6,
    large: 9,
    extraLarge: 12,
    huge: 20,
    circle: 99999,
    pill: 99999,
    button: 3,
    inputField: 6,
  },
  zIndices: {
    default: 1,
    sticky: 100,
    dropdown: 4000,
    tooltip: 5000,
    modal: 8000,
    toast: 9000,
  },
  rem: {
    fontSizes: {
      headingOne: 2,
      headingTwo: 1.5,
      headingThree: 1.25,
      headingFour: 1.125,
      subtitleOne: 1,
      subtitleTwo: 0.875,
      bodyOne: 1,
      bodyOneSecondary: 1,
      bodyTwo: 0.875,
      bodyTwoSecondary: 0.875,
      buttonOne: 1,
      buttonTwo: 0.875,
      label: 0.75,
      overline: 0.75,
      caption: 0.75,
      tab: 0.625,
    },
    lineHeights: {
      headingOne: 2.5,
      headingTwo: 2,
      headingThree: 1.75,
      headingFour: 1.5,
      subtitleOne: 1.5,
      subtitleTwo: 1.25,
      bodyOne: 1.5,
      bodyOneSecondary: 1.5,
      bodyTwo: 1.25,
      bodyTwoSecondary: 1.25,
      buttonOne: 1.5,
      buttonTwo: 1.25,
      label: 1,
      overline: 1,
      caption: 1,
      tab: 0.75,
    },
    baseSize: 16,
  },
  fonts: {
    headings: 'Mark Offc Pro',
    body: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
  },
  transitions: { defaultTime: '200ms' },
};
